module.exports = __webpack_public_path__ + "img/compliant-law-25-en.fc3aeb36.png";